import React, { useState } from "react";
// External dependencies
import axios from "axios";
import { useSelector } from "react-redux";
// Internal dependencies
import { handleDropdownClick } from "../../../utils/functions/handleDropdownClick";
// Css files
import "./HeaderSearchBar.css";
// Components
import SearchInput from "../../../components/common/inputs/SearchInput";

const HeaderSearchBar = ({ isHeaderSearch, setDropdownState }) => {
  const [searchData, setSearchData] = useState("");
  const [isError, setisError] = useState(true);
  const [isLoading, setisLoading] = useState(false);
  const sessionList = useSelector((state) => state.sessionData.sessionScope);

  const handleChange = (event) => {
    if (event.target.value.length > 2) {
      setisError(false);
    } else setisError(true);
  };
  const getData = async (e) => {
    if (e.key === "Enter" && !isError) {
      setisLoading(true);
      let headersList = {
        "X-CSRF-TOKEN":
          sessionList[
            "org.springframework.security.web.csrf.HttpSessionCsrfTokenRepository.CSRF_TOKEN"
          ].token,
        "Content-Type": "application/x-www-form-urlencoded",
      };
      let bodyContent = `search=${e.target.value}`;
      axios
        .post("/searchdashboard", bodyContent, {
          headers: headersList,
        })
        .then((response) => {
          setisLoading(false);
          setSearchData(response.data);
        });
    }
  };
  return (
    <>
      <span
        className="m-nav__link m-dropdown__toggle"
        title="Search"
        style={{ cursor: "pointer" }}
        onClick={() => handleDropdownClick("isHeaderSearch", setDropdownState)}
      >
        <span className="m-nav__link-icon">
          <i className="fa fa-search"></i>
        </span>
      </span>
      {isHeaderSearch && (
        <div
          className="m-quick-sidebar-overlay"
          onClick={() => handleDropdownClick(!isHeaderSearch, setDropdownState)}
          onContextMenu={() =>
            handleDropdownClick(!isHeaderSearch, setDropdownState)
          }
        ></div>
      )}
      <div
        id="search_bar_header"
        className={`m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light card-body-sm ${
          isHeaderSearch ? "m-quick-sidebar--on" : ""
        }`}
      >
        <div className="m-quick-sidebar__content1">
          <span
            id="m_quick_sidebar_close"
            className="m-quick-sidebar__close "
            style={{ top: "10px" }}
            onClick={() =>
              handleDropdownClick(!isHeaderSearch, setDropdownState)
            }
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </span>
          <div className="text-right m--padding-top-10">
            <div className="col-md-12 p-0">
              <div className="m-form__group">
                <SearchInput
                  name=""
                  id="global_search"
                  placeholder="Search"
                  onKeyDown={getData}
                  onChange={handleChange}
                />
                {isError && (
                  <span
                    style={{ color: "#dc3545", float: "left" }}
                    id="help_msg"
                  >
                    Minimum 3 Character Required{" "}
                  </span>
                )}
                {isLoading && (
                  <span style={{ fontSize: "15px", float: "left" }}>
                    Loading...
                  </span>
                )}
              </div>
            </div>
          </div>
          <div
            className="col-12 p-0 m-scrollable m-scroller ps ps--active-y"
            data-scrollable="true"
            data-mobile-height="300"
            data-height="500"
            style={{ height: "100%", overflowY: "auto", maxHeight: "500px" }}
            id="global_search_past_here"
            dangerouslySetInnerHTML={{ __html: searchData }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default HeaderSearchBar;
